import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';

/**
 * Outlined secondary action with a subtle primary gradient tint (matches PrimaryButton family).
 */
export default function OutlinePrimaryButton({
  children,
  onClick,
  disabled = false,
  type = 'button',
  style = {},
  size = 'md',
  className = '',
  ...rest
}) {
  const { colors } = useTheme();
  const primaryRgb = '99, 102, 241';
  const gradient = `linear-gradient(135deg, rgba(${primaryRgb}, 0.14), rgba(${primaryRgb}, 0.06))`;

  const sizeStyles = {
    sm: { fontSize: '0.85em', padding: '6px 14px', minHeight: 32 },
    md: { fontSize: '0.9em', padding: '7px 16px', minHeight: 36 },
  };

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={className}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 6,
        borderRadius: 50,
        border: `1px solid ${colors.primary}`,
        background: gradient,
        color: colors.primary,
        fontWeight: 600,
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.65 : 1,
        outline: 'none',
        whiteSpace: 'nowrap',
        transition: 'box-shadow 0.2s, transform 0.2s, filter 0.2s',
        boxShadow: `0 1px 4px rgba(${primaryRgb}, 0.12)`,
        ...sizeStyles[size],
        ...style,
      }}
      onMouseEnter={(e) => {
        if (!disabled) {
          e.currentTarget.style.boxShadow = `0 2px 8px rgba(${primaryRgb}, 0.22)`;
          e.currentTarget.style.filter = 'brightness(1.04)';
        }
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.boxShadow = `0 1px 4px rgba(${primaryRgb}, 0.12)`;
        e.currentTarget.style.filter = 'none';
      }}
      {...rest}
    >
      {children}
    </button>
  );
}
